<app-card-auth
  title="Reset Password"
  description="Please enter the email address that you used to register, and we will send you a link to reset your password via Email."
>
  <reset-password-form
    [signInLink]="defaultLink"
    [buttonLink]="buttonLink"
  ></reset-password-form>
</app-card-auth>
